import Header34 from './Header34'
export default Header34
